import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[href]',
})
export class HrefPreventDefaultDirective {
    @Input() href?: string;

    @HostListener('click', ['$event'])
    preventDefault(event: Event) {
        if (this.href !== undefined && (this.href.length === 0 || this.href === '#')) {
            event.preventDefault();
        }
    }
}
